export default function CvDocumentIcon({ className }) {
  return <svg className={className} width="30" height="30" viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M9 3h17l7 7v27H7V3h2Zm17 0v8h7" />
    <circle cx="16" cy="15" r="3" />
    <path d="M10.5 24v-2a5.5 5.5 0 0 1 11 0v2ZM25 17h4m-4 5h4M11 29h18m-18 4h13" />
  </svg>;
}
